import { useTranslate } from '@festina-life/ui/hooks'
import { Table, TBody, Th, THead, Tr } from '@festina-life/ui/listsAndTables'

import { useTemplateContext } from '../../context/templateContext'
import { isNotRelevantField } from '../../types/templateModel'
import { TemplateReferenceAddVariantRow } from './TemplateReferenceAddVariantRow'
import { TemplateReferenceExpresssionsTableRow } from './TemplateReferenceExpresssionsTableRow'
import type { TemplateReferenceTableProps } from './types'

export const TemplateReferencesExpressionsTable = ({
  errors,
  field,
  onChange,
  rowClassName,
  isExpanded,
}: TemplateReferenceTableProps) => {
  const translate = useTranslate()
  const { isDraftTemplate } = useTemplateContext()

  return (
    <>
      {isDraftTemplate && isExpanded && !isNotRelevantField(field) && (
        <TemplateReferenceAddVariantRow field={field} />
      )}
      <Table className="table-fixed">
        <THead>
          <Tr>
            <Th className={`${rowClassName} w-1/4`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.templateReference',
              )}
            </Th>
            <Th className={`${rowClassName} w-1/4`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.defaultSelected',
              )}
            </Th>
            <Th className={`${rowClassName} w-1/4`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.selectable',
              )}
            </Th>
            <Th className={`${rowClassName} w-1/4`}>
              {translate(
                'templateViewer.templateReferenceViewer.modal.columnHeader.required',
              )}
            </Th>
          </Tr>
        </THead>
        <TBody>
          {(field.value?.variants ?? []).map((templateVariant, index) => (
            <TemplateReferenceExpresssionsTableRow
              errors={errors[index] ?? []}
              key={templateVariant.source}
              data={templateVariant}
              fieldPath={field.path}
              onChange={
                onChange ? (nextValue) => onChange(nextValue, index) : undefined
              }
            />
          ))}
        </TBody>
      </Table>
    </>
  )
}
